module.exports = __webpack_public_path__ + "ba13674a2213b5783cce0ba48f347883.pdf";